import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";
import anim_line from "../../img/winter.png"
import { useParams ,useHistory, useRouteMatch,} from "react-router-dom";

import LoadingButton from "../../Loading/LoadingButton";
import { useSelector } from "react-redux";
import {Activity, CircleMinus, CirclePlay, CirclePlus, FrameIcon } from 'lucide-react';
import Snackbar from "../../../Snackbar";
import { createCourseByAdminV2 } from "../../../store/actions/CreateCourse/createCourseByAdmin";
import AppMenuCardBlue from "../AppCards/AppMenuCardBlue";
import { getProductByProductId } from "../../../api";
import AreYouSurePopUp from "../../Create/CreateContent/ContentPopUp/AreYouSurePopUp";
import AppMenuCardBlueBG from "../AppCards/AppMenuCardBlueBG";
import NextStepCardPopUp from "../AppCards/NextStepCardPopUp";
import Toggle from "../../UI/Toggle";
import { DayPicker } from "react-day-picker";
import { ChevronRight,ChevronLeft,X,Plus,Minus} from 'lucide-react';
  
const FreeTrial = ({setActiveCardOverview,baseUrl,producttype})=>{
  const {courseId} = useParams();
  const {url}=useRouteMatch();
  const history = useHistory();
   const dispatch = useDispatch();

   const [snackbarVisible, setSnackbarVisible] = useState(false);
   const [snackbarColor, setSnackbarColor] = useState("rgba(144, 202, 249,1)");
   const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
 
  const [goNextPopUp, setGoNextPopUp] =useState(false);
 
 const showSnackbar = () => {
   setSnackbarVisible(true);
 };

 const hideSnackbar = () => {
   setSnackbarVisible(false);
 };
 const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
  {
    
    dispatch({type: "CURSOR",payload:true  });

    dispatch({type: "CURSORTEXT",payload:CursorText})
    dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
    dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
  }
   
  const handleMouseLeave = () => {
    
    dispatch({type: "CURSOR",payload:false})

    dispatch({type: "CURSORTEXT",payload:""})

    dispatch({type: "CURSORTEXTBG",payload:""})
    dispatch({type: "CURSORTEXTCOLOR",payload:""})
  

}
  
 const token = useSelector((state)=>state?.course?.course?.token);
 const currentToken = useSelector((state)=>state?.user?.user?.token);
 const user_email = useSelector((state)=>state?.user?.user?.user_email
);

const postIdCourse = useSelector((state)=>state?.course?.course?.postId);

const courseData = useSelector((state)=>state?.course?.course);
const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
const appId = useSelector((state)=>state?.app?.app?.ID);
const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);

const [loader , setLoader] =useState({status:false});
const [loaderTrialStatus , setLoaderTrialStatus] =useState({status:false});
const [loaderTrialType , setLoaderTrialType] =useState({status:false});
const [loaderTrialValue , setLoaderTrialValue] =useState({status:false});
  const [productID, setProductID] = useState(courseData?.ID?courseData?.ID:"");
  let trialValidityStatusVal = courseData?.trialValidityStatus?JSON.parse(courseData?.trialValidityStatus):false;
  let trialexipiryDateRangeVal = courseData?.trialexipiryDateRange?JSON.parse(courseData?.trialexipiryDateRange):false;
  const [trialexipiryDateRange ,setTrialexipiryDateRange] =useState(trialexipiryDateRangeVal)
  const [trialValidityStatus ,setTrialValidityStatus] =useState(trialValidityStatusVal)
  const [trialValidityType ,setTrialValidityType] =useState(courseData?.trialValidityType?courseData?.trialValidityType:"")
  
 const [editType, setEditType] = useState(courseData?.ID?"trialValidityStatus":"");
 let TypeTitle= courseData?.ID?courseData?.type=='course'?"Course":
  courseData?.type=='batch'?"Batch":
  courseData?.type=="testSeries"?"Test Series":
  courseData?.type=="homeTutor"?"Home Tutor Offering":
  courseData?.type=="bundle"?"Bundle":
courseData?.type=="digitalProduct"?"Digital Product":"Course":"Course";
 const [animate, setAnimate] = useState(false);

      useEffect(()=>{
        setActiveCardOverview(true);
        
        // setCourseTitleData();
      },[])
   
 useEffect(() => {setAnimate(false); 
   // Trigger the animation after a delay (e.g., 500ms)
   const timer = setTimeout(() => {
    setAnimate(true);  
  }, 500);

   return () => clearTimeout(timer); // Cleanup on unmount
 }, [trialValidityType,trialValidityStatus]);
useEffect(()=>{
  setActiveCardOverview(true);
  
  // setCourseTitleData();
},[])



  const handleCreateProduct=(trialValidityStatus)=>{
  
  
  
  setLoaderTrialStatus({status:true});
  
    const apiData = dispatch(createCourseByAdminV2({trialValidityStatus:JSON.stringify(trialValidityStatus),type:courseData?.ID?courseData?.type:producttype?producttype:"course",
      postParent:"0" ,userEmail:user_email?user_email:"",
      currentToken:currentToken?currentToken:"",
      editType:editType,postId:productID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}));
    /* get response as Promise   */
    apiData.then(response => {
      if(response){
        if(response?.course){
          
      setResponseMessage(response?.message);
      setSnackbarColor("rgba(144, 202, 249,1)");
    
       
  setLoaderTrialStatus({status:false});
  
//   setSnackbarVisible(true);
  setTimeout(()=>{
    
    // setSnackbarVisible(false);
    setTrialValidityStatus(JSON.parse(response?.course?.trialValidityStatus));
    setProductID(response?.course?.postId);
   setEditType("trialValidityStatus")
//    setGoNextPopUp(true);
  },1000)
     }else{
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("rgba(144, 202, 249,1)");
   
       
  setLoaderTrialStatus({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
     }
        
     
     if(response?.logout){
     
      setResponseMessage("You are Logged Out!!!");
        
      setSnackbarColor("rgba(144, 202, 249,1)");
   
       
  setLoaderTrialStatus({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      setTimeout(()=>{
        dispatch({type:"LOGOUT"});
  
      },3000)
      
    }
  /* resetting Login input Fields */
  
      }else{
        setResponseMessage("Something Went Wrong...");
        
        setSnackbarColor("rgba(144, 202, 249,1)");
     
         
    setLoaderTrialStatus({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)    }
  
    }).catch(error => {
   
      //popup of error Info
      setResponseMessage("Something Went Wrong...");
        
      setSnackbarColor("rgba(144, 202, 249,1)");
   
       
  setLoaderTrialStatus({status:false});
  
  setSnackbarVisible(true);
  setTimeout(()=>{
    
    setSnackbarVisible(false);
   
     
  },3000)
      console.error(error);
    });
   
    }
    
  const handleCreateProductValidityType=(trialValidityType)=>{
  
  
  
    setLoaderTrialType({status:true});
    
      const apiData = dispatch(createCourseByAdminV2({trialValidityType:trialValidityType,type:courseData?.ID?courseData?.type:producttype?producttype:"course",
        postParent:"0" ,userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:"trialValidityType",postId:productID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}));
      /* get response as Promise   */
      apiData.then(response => {
        if(response){
          if(response?.course){
            
        setResponseMessage(response?.message);
        setSnackbarColor("rgba(144, 202, 249,1)");
      
         
    setLoaderTrialType({status:false});
    
  //   setSnackbarVisible(true);
    setTimeout(()=>{
      
      // setSnackbarVisible(false);
      setTrialValidityType(response?.course?.trialValidityType);
      setProductID(response?.course?.postId);
   
  //    setGoNextPopUp(true);
    },1000)
       }else{
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("rgba(144, 202, 249,1)");
     
         
    setLoaderTrialType({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
       }
          
       
       if(response?.logout){
       
        setResponseMessage("You are Logged Out!!!");
          
        setSnackbarColor("rgba(144, 202, 249,1)");
     
         
    setLoaderTrialType({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        setTimeout(()=>{
          dispatch({type:"LOGOUT"});
    
        },3000)
        
      }
    /* resetting Login input Fields */
    
        }else{
          setResponseMessage("Something Went Wrong...");
          
          setSnackbarColor("rgba(144, 202, 249,1)");
       
           
      setLoaderTrialType({status:false});
      
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
       
         
      },3000)    }
    
      }).catch(error => {
     
        //popup of error Info
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("rgba(144, 202, 249,1)");
     
         
    setLoaderTrialType({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        console.error(error);
      });
     
      }
      

   const [totalNo, setTotalNo] = useState(courseData?.trialdurationValue?JSON.parse(courseData?.trialdurationValue)?.validityCount:5);
   let trialdurationValue = courseData?.trialdurationValue?JSON.parse(courseData?.trialdurationValue):""; 
   const [durationTypeVal, setDurationTypeVal] = useState(trialdurationValue);

   const [itemArr, setItemArr] = useState({validityCount:1,validityDurationType:"months"});

    
   const changetotalNumber = ( totalNumber) => {
    // const validityValue= { validityCount:totalNumber,
    //    validityDurationType:itemArr?.validityValue?.validityDurationType}
    
       setItemArr({...itemArr,validityCount:totalNumber,});
       handleCreateProductValidityDuration({validityCount:totalNumber,validityDurationType:itemArr?.validityDurationType})
    
   };
   
   const changeDurationType = ( durationType) => {
    
    //  const validityValue= { expiryDate:"",validityCount:itemArr?.validityValue?.validityCount,
    //    validityDurationType:durationType,lifeTimeValidity:true}
     
        setItemArr({...itemArr,validityDurationType:durationType});
        handleCreateProductValidityDuration({validityCount:itemArr?.validityCount,validityDurationType:durationType})
    
   };
  
   useEffect(() => {
    setTotalNo(courseData?.trialdurationValue?JSON.parse(courseData?.trialdurationValue)?.validityCount:5)
         setDurationTypeVal(courseData?.trialdurationValue?JSON.parse(courseData?.trialdurationValue)?.validityDurationType:"days");
          // Trigger the animation after a delay (e.g., 500ms)
          const timer = setTimeout(() => {
           setAnimate(true);  
         }, 100);
       
          return () => clearTimeout(timer); // Cleanup on unmount
        }, []);
        const handleCreateProductValidityDuration=(trialdurationValue)=>{
  
  
  
            setLoaderTrialValue({status:true});
            
              const apiData = dispatch(createCourseByAdminV2({trialdurationValue:JSON.stringify(trialdurationValue),type:courseData?.ID?courseData?.type:producttype?producttype:"course",
                postParent:"0" ,userEmail:user_email?user_email:"",
                currentToken:currentToken?currentToken:"",
                editType:"trialdurationValue",postId:productID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}));
              /* get response as Promise   */
              apiData.then(response => {
                if(response){
                  if(response?.course){
                    
                setResponseMessage(response?.message);
                setSnackbarColor("rgba(144, 202, 249,1)");
              
                 
            setLoaderTrialValue({status:false});
            
          //   setSnackbarVisible(true);
            setTimeout(()=>{
              
              // setSnackbarVisible(false);
              setItemArr(JSON.parse(response?.course?.trialdurationValue));
              setProductID(response?.course?.postId);
             
          //    setGoNextPopUp(true);
            },1000)
               }else{
                setResponseMessage("Something Went Wrong...");
                  
                setSnackbarColor("rgba(144, 202, 249,1)");
             
                 
            setLoaderTrialValue({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
               }
                  
               
               if(response?.logout){
               
                setResponseMessage("You are Logged Out!!!");
                  
                setSnackbarColor("rgba(144, 202, 249,1)");
             
                 
            setLoaderTrialValue({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                setTimeout(()=>{
                  dispatch({type:"LOGOUT"});
            
                },3000)
                
              }
            /* resetting Login input Fields */
            
                }else{
                  setResponseMessage("Something Went Wrong...");
                  
                  setSnackbarColor("rgba(144, 202, 249,1)");
               
                   
              setLoaderTrialValue({status:false});
              
              setSnackbarVisible(true);
              setTimeout(()=>{
                
                setSnackbarVisible(false);
               
                 
              },3000)    }
            
              }).catch(error => {
             
                //popup of error Info
                setResponseMessage("Something Went Wrong...");
                  
                setSnackbarColor("rgba(144, 202, 249,1)");
             
                 
            setLoaderTrialValue({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                console.error(error);
              });
             
              }
    
      const handleCreateProductValidityDateRange=(trialexipiryDateRange)=>{
  
  
  
        setLoaderTrialValue({status:true});
        
          const apiData = dispatch(createCourseByAdminV2({trialexipiryDateRange:JSON.stringify(trialexipiryDateRange),type:courseData?.ID?courseData?.type:producttype?producttype:"course",
            postParent:"0" ,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:"trialexipiryDateRange",postId:productID,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}));
          /* get response as Promise   */
          apiData.then(response => {
            if(response){
              if(response?.course){
                
            setResponseMessage(response?.message);
            setSnackbarColor("rgba(144, 202, 249,1)");
          
             
        setLoaderTrialValue({status:false});
        
      //   setSnackbarVisible(true);
        setTimeout(()=>{
          
          // setSnackbarVisible(false);
          setTrialexipiryDateRange(JSON.parse(response?.course?.trialexipiryDateRange));
          setProductID(response?.course?.postId);
         
      //    setGoNextPopUp(true);
        },1000)
           }else{
            setResponseMessage("Something Went Wrong...");
              
            setSnackbarColor("rgba(144, 202, 249,1)");
         
             
        setLoaderTrialValue({status:false});
        
        setSnackbarVisible(true);
        setTimeout(()=>{
          
          setSnackbarVisible(false);
         
           
        },3000)
           }
              
           
           if(response?.logout){
           
            setResponseMessage("You are Logged Out!!!");
              
            setSnackbarColor("rgba(144, 202, 249,1)");
         
             
        setLoaderTrialValue({status:false});
        
        setSnackbarVisible(true);
        setTimeout(()=>{
          
          setSnackbarVisible(false);
         
           
        },3000)
            setTimeout(()=>{
              dispatch({type:"LOGOUT"});
        
            },3000)
            
          }
        /* resetting Login input Fields */
        
            }else{
              setResponseMessage("Something Went Wrong...");
              
              setSnackbarColor("rgba(144, 202, 249,1)");
           
               
          setLoaderTrialValue({status:false});
          
          setSnackbarVisible(true);
          setTimeout(()=>{
            
            setSnackbarVisible(false);
           
             
          },3000)    }
        
          }).catch(error => {
         
            //popup of error Info
            setResponseMessage("Something Went Wrong...");
              
            setSnackbarColor("rgba(144, 202, 249,1)");
         
             
        setLoaderTrialValue({status:false});
        
        setSnackbarVisible(true);
        setTimeout(()=>{
          
          setSnackbarVisible(false);
         
           
        },3000)
            console.error(error);
          });
         
          }





    const [selected, setSelected] = useState(null);


       const [selectedDate, setSelectedDate] = useState(null);
            const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
            const [startYear, setStartYear] = useState(2020);
            const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
            const [statusYear,setStatusYear]=useState(false)
            const [statusMonth,setStatusMonth]=useState(false)
            const [statusCalendar,setStatusCalendar]=useState(true)
            const [startDate,setStartDate]=useState("")
            const [endDate,setEndDate]=useState("")
            
            function getYearAndMonth(dateString) {
              // Split the input string by the '-' delimiter
              const [day, month, year] = dateString.split('-');
          
              // Return an object containing the year and month
              return {
                  year: parseInt(year, 10),
                  month: parseInt(month, 10)
              };
          }
          
         
const modifiers = {
    weekend: { dayOfWeek: [0, 6] },  // Highlight weekends
    // holiday: [new Date(2024, 11, 25), new Date(2024, 0, 1)] ,

    //   start: selected?.from,       // Modifier for the start date
    //     end: selected?.to 
  };
  
  const modifiersStyles = {
    weekend: {   borderRadius:"50%",background:"#f1f1f1"},
    // holiday: { color: "red", backgroundColor: "yellow" },
    selected:{ backgroundColor: "rgba(149, 143, 218,0.11)", },
    start: { color: "#fff" , backgroundColor: "rgba(149, 143, 218,1)",borderRadius:"50%"},       // Class for the start date
        end: { color: "#fff" , backgroundColor: "rgba(149, 143, 218,1)",borderRadius:"50%"}
  };
 
 useEffect(() => {
      setSelectedDate(trialexipiryDateRange?.selected);
      setSelected(formatDateString(trialexipiryDateRange?.selected));
     
     
     if(courseData?.trialexipiryDateRange?.date){
      // const date = new Date(courseData?.CourseDuration?.validityValue?.expiryDate?.date);
       // Example usage
    const date = courseData?.trialexipiryDateRange?.date;
    const result = getYearAndMonth(date);
   setSelectedMonth(result?.month-1);
  setSelectedYear(result?.year);
     } 
       // Trigger the animation after a delay (e.g., 500ms)
       const timer = setTimeout(() => {
        setAnimate(true);  
      }, 100);
    
       return () => clearTimeout(timer); // Cleanup on unmount
     }, []);
    
    
  const handleDayClick = (day) => {
     // alert(`You clicked ${date.toDateString()}`);
    //  console.log(formatDateString(day))
setSelected(formatDateString(day));
handleCreateProductValidityDateRange({selected:day,from:formatDateString(day?.from),to:formatDateString(day?.to)});

    //  console.log({selected:day,date:formatDateString(day)})
   
  };
  function formatDateString(dateString) {
  // Parse the date string into a Date object
  const date = new Date(dateString);
  
  // Extract day, month, and year
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const year = date.getFullYear();
  
  // Format as "DD-MM-YYYY"
  return `${day}-${month}-${year}`;
}










  const handlePrevious = () => {
    setStartYear((prev) => Math.max(1900, prev - 10));
  };

  const handleNext = () => {
    setStartYear((prev) => Math.min(2100 - 9, prev + 10));
   
  };

  const handleSelectMonth = (month) => {
    setSelectedMonth(month);setStatusMonth(false)
    setStatusCalendar(true)
  };
  function YearGrid({ startYear, onSelectYear, selectedYear, onPrevious, onNext }) {
    const years = Array.from({ length: 10 }, (_, i) => startYear + i);
  
    return (
      <div style={{width:"320px",marginBottom: "10px" ,marginTop: "10px"}}>
        <div style={{ display: "flex",
             justifyContent: "space-between" , padding:"10px",background:"#fff",padding:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.051)",borderRadius: "15px",marginBottom: "10px" ,marginTop: "10px"}}>
       
    <div  onClick={()=>{setStatusYear(false)
        setStatusMonth(false);
    setStatusCalendar(true)}} style={{ color: "#fff" ,cursor:"pointer",width:"30px",height:"30px", border: "2px solid rgba(149, 143, 218,1)",borderRadius:"50%",}} 
    ><ChevronLeft style={{marginRight:"1px"}}  color="rgba(149, 143, 218,1)" size={30}/> </div>
     
     <button style={{  fontSize:"14px",padding:"6px",textAlign:"center",cursor:"pointer",width:"80px",
         border: `${startYear <= 1900
            ?"2px solid rgba(149, 143, 218,0.41)":"2px solid rgba(149, 143, 218,1)"}`,borderRadius:"10px",}} 
         onClick={onPrevious} disabled={startYear <= 1900}>
            Previous
          </button>
          <div style={{padding:"5px"}}>Select Year</div>
          <button  style={{ fontSize:"14px",padding:"6px",textAlign:"center",
            cursor:"pointer",width:"80px", border: 
            `${startYear + 25 > 2100
            ?"2px solid rgba(149, 143, 218,0.41)":"2px solid rgba(149, 143, 218,1)"}`
            ,borderRadius:"10px",}} onClick={onNext} disabled={startYear + 25 > 2100}>
            Next
          </button>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: "10px",background:"#fff",padding:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.051)",borderRadius: "15px",}}>
          {years.map((year) => (
            <button
              key={year}
              onClick={() => {onSelectYear(year);
                setStatusYear(false) ;
                setStatusMonth(true)
                setStatusCalendar(false)
              }}
              style={{
                padding: "10px",height:"90px",
                backgroundColor: year === selectedYear ? "rgba(149, 143, 218,1)" : "#f0f0f0",
                color: year === selectedYear ? "white" : "black",
                borderRadius: "5px",
                border: "1px solid #ddd",
                cursor: "pointer"
              }}
            >
              {year}
            </button>
          ))}
        </div>
      </div>
    );
  }
  function MonthGrid({ onSelectMonth, selectedMonth }) {
    
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
  
    return (<>  <div style={{width:"320px",padding:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.051)",borderRadius: "15px",background:"#fff" ,display: "flex", justifyContent: "space-between", marginBottom: "10px",marginTop: "10px"  }}>
       
        <div  onClick={()=>{setStatusYear(false)
            setStatusMonth(false);
        setStatusCalendar(true)}} 
        style={{ color: "#fff" ,cursor:"pointer",width:"30px",height:"30px", border: "2px solid rgba(149, 143, 218,1)",borderRadius:"50%",}} 
        ><ChevronLeft style={{marginRight:"1px"}}  color="rgba(149, 143, 218,1)" size={30}/> </div>
        
              <div style={{padding:"5px"}}>Select Month</div>
             <div style={{ fontSize:"14px",padding:"6px",textAlign:"center",cursor:"pointer",width:"100px", border: "2px solid rgba(149, 143, 218,1)",borderRadius:"10px",}}  onClick={()=>{setStatusYear(true)
        setStatusMonth(false);
    setStatusCalendar(false)}}> Change Year</div>
    
            </div> 
      <div style={{width:"320px", padding:"10px",display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "10px", marginBottom: "10px"
       ,boxShadow:"0 7px 20px 0 rgba(1,1,1,0.051)",borderRadius: "15px",background:"#fff" }}>
        {months.map((month, index) => (
          <button
            key={month}
            onClick={() => onSelectMonth(index)}
            style={{
              padding: "10px",
              backgroundColor: index === selectedMonth ? "rgba(149, 143, 218,1)" : "#f0f0f0",
              color: index === selectedMonth ? "white" : "black",
              borderRadius: "5px",
              border: "1px solid #ddd",
              cursor: "pointer"
            }}
          >
            {month}
          </button>
        ))}
      </div>
      </>);
  }
   
    return <>
    
{<>
  {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}

<div  className="ikcraft_login-signup-card-outerj"><div  className="CreateCourseStepsOuterTwo contentPageScroller " style={{background:"#fff",borderRadius:"25px"}}>
  <div  className=" ">
   
      <h1 style={{"textAlign":"center",
        transform: animate ? 'translateY(0)' : 'translateY(-50px)',marginBottom:"0px",
        opacity: animate ? 1 : 0,
        transition: 'transform 1s ease, opacity 1s ease',
      }}>   Want To Enable  <span className="coloredTextV1" >Free Trial </span>For Your {TypeTitle}? </h1>
      
 <div  className="ikcraft_login-input-card"style={{
        transform: animate ? 'translateY(0)' : 'translateY(-50px)',
        opacity: animate ? 1 : 0,
        transition: 'transform 2s ease, opacity 1s ease',
      }}><div className="gridForFiftyFixed"><div><h4>{loaderTrialStatus?.status?"loading...":"Set Free Trial Validity"} </h4></div>
      <Toggle state={trialValidityStatus} toggleState={(state)=>{setTrialValidityStatus(state);handleCreateProduct(state);}} />
         </div>
{trialValidityStatusVal?
         <div class="input-card-outer"style={{
            transform: animate ? 'translateY(0)' : 'translateY(50px)',
            opacity: animate ? 1 : 0,
            transition: 'transform 3s ease, opacity 3s ease',
          background:"#fcfcfc",borderRadius:"25px",padding:"5px"}} >
                                    
                                    <div class="input-card-radio">
                                    <label onMouseEnter={
                               ()=>handleMouseEnter("#fff","#333","")}
     onMouseLeave={handleMouseLeave} className={"boxCard-outer"}>
                                       
                                          <div >{loaderTrialType?.status?"loading...":"Duration"}</div> 
                                       
                                                <input type="radio" title="Duration"  

          checked={trialValidityType=="Duration"?"yes":""}
                                                 className="input-textbox"  value="Duration"  name="coursePriceType"  
     onChange={e=>{
      
        handleCreateProductValidityType(e.target.value)
        setTrialValidityType(e.target.value);
   
    
    }

       
    }
    />
                                                   <span class={"boxCardBorder"}></span>
                                          </label>
                                          <label onMouseEnter={()=>
                       handleMouseEnter("#fff","#333","")}
     onMouseLeave={handleMouseLeave} className={"boxCard-outer"}>
                                       
                                       <div  >{loaderTrialType?.status?"loading...":"Expiry Date"}</div> 
                                      
                                               <input  type="radio" title="ExpiryDate"  
                                       checked={trialValidityType=="ExpiryDate"?"yes":""}         className="input-textbox"  value="ExpiryDate" 
                                                 name="coursePriceType"  
                                                //  checked={freePaidStatus=="Paid"?true:false}
    onChange={e=>{
        handleCreateProductValidityType(e.target.value);
        setTrialValidityType(e.target.value);
      }
      
   }
   />
                                                  <span class={"boxCardBorder"}></span>
                                         </label>



                                  
    </div> </div>:""}
   </div>
     
   
   {/* <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
    <div  >   </div>
  
    
    <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{}}  className="CreateCourseStepsOuterRightButtonBack"  type="submit"
     id="signupBtn"> Back </button>

 <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{handleCreateProduct()}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
     id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":productID?"Update":"Save"} </button>
     
  </div> */}
  
    

  <div> 
    
    
    
    
  </div>
   </div>
 <div  style={{
        transform: animate ? 'translateY(0)' : 'translateY(50px)',
        opacity: animate ? 1 : 0,
        transition: 'transform 3s ease, opacity 3s ease',
      background:"#fcfcfc",borderRadius:"25px",padding:"5px",display:"flex",justifyContent:"center"}} > 


{trialValidityStatus&&trialValidityType=="ExpiryDate"? <div>
{statusMonth?<MonthGrid onSelectMonth={handleSelectMonth} selectedMonth={selectedMonth} />
     :""}
    {statusYear?<YearGrid
        startYear={startYear}
        onSelectYear={setSelectedYear}
        selectedYear={selectedYear}
        onPrevious={handlePrevious}
        onNext={handleNext}
      />  :""}
      {statusCalendar?<div style={{"textAlign":"center",
        transform: animate ? 'translateY(0)' : 'translateY(100px)',marginBottom:"0px",
        opacity: animate ? 1 : 0,
        transition: 'transform 2s ease, opacity 2s ease',
      }}> <nav  style={{width:"320px",padding:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.051)",borderRadius: "15px",background:"#fff" , display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "10px", marginBottom: "10px" ,marginTop: "10px" }} aria-label="">
      <div style={{ fontSize:"14px",padding:"6px",textAlign:"center",cursor:"pointer",width:"100px", border: "2px solid rgba(149, 143, 218,1)",borderRadius:"10px",}}  onClick={()=>{setStatusYear(true)
        setStatusMonth(false);
    setStatusCalendar(false)}}> Change Year</div>
      <div 
      style={{  fontSize:"14px",padding:"6px",textAlign:"center",cursor:"pointer",width:"100px", border: "2px solid rgba(149, 143, 218,1)",borderRadius:"10px",}}  onClick={()=>{setStatusYear(false)
        setStatusMonth(true);
    setStatusCalendar(false)}}>Change Month</div>
    
     <div  style={{ color: "#fff" ,cursor:"pointer",width:"30px",height:"30px", border: "2px solid rgba(149, 143, 218,1)",borderRadius:"50%",}} onClick={()=>{handleSelectMonth(selectedMonth-1)} } ><ChevronLeft style={{marginRight:"1px"}}  color="rgba(149, 143, 218,1)" size={30}/> </div>
     <div style={{ color: "#fff" ,cursor:"pointer",width:"30px",height:"30px", border: "2px solid rgba(149, 143, 218,1)",borderRadius:"50%",}} onClick={()=>{handleSelectMonth(selectedMonth+1)} } > <ChevronRight style={{marginLeft:"1px"}} color="rgba(149, 143, 218,1)" size={30}/></div>
      </nav>
       <DayPicker 
           //   fromYear={1900}  // Start year for the dropdown
           //   toYear={2100}    // End year for the dropdown
           //   captionLayout="dropdown"  // Use dropdown layout for month and year
        
             numberOfMonths={1}
               mode="range"
               selected={selectedDate}
               onSelect={(date)=>{setSelectedDate(date)
                   setStartDate(formatDateString(date?.from));
         
                   setEndDate(formatDateString(date?.to))
                   handleDayClick(date)
                   
                }}
               month={new Date(selectedYear, selectedMonth)}// Show the selected year in the calendar
               modifiers={modifiers}
               labelsFormatters={{
                 formatWeekdayName: (day) => day.toLocaleDateString("es-ES", { weekday: "short" })
               }} 
               styles={{
                   caption: { color: "#99cc99" },
                   day: { borderRadius: "50%" },
                  
                 }}
               components={{
             Caption: ({ month }) => <strong>{month.toLocaleString('default', { month: 'long' })}</strong>,
             Footer: () => <p>Select your preferred date.</p>
         
           }}
           
           onDayClick={()=>{}}
            disabled={[
                 { before: new Date() }, // Disable past dates
                 // { dayOfWeek: [0] } // Disable weekends
               ]}
               modifiersStyles={modifiersStyles}
               // dayContentRenderer={(day) => (
               //   <div style={{ textAlign: 'center' }}>
               //     {day.getDate()}
               //     {day.getDay() === 0 && <span role="img" aria-label="holiday">🌟</span>} {}
               //   </div>
               // )}
               // showWeekNumber
          
           // footer={<p>End of Calendar</p>}
           // renderDay={(day) => (
           //   <div style={{ position: "relative" }}>
           //     <span>{day.getDate()}</span>
           //     {day.getDate() === 1 && <span style={{ color: "red" }}>Start</span>}
           //   </div>
           // )}
                /></div>:""}

</div>:trialValidityStatus&&trialValidityType=="Duration"?<div  style={{"textAlign":"center",
        transform: animate ? 'translateY(0)' : 'translateY(100px)',marginBottom:"0px",
        opacity: animate ? 1 : 0,
        transition: 'transform 2s ease, opacity 2s ease',
      }}>
   <div>
        
  
        <div class="input-card-radio" >
                                 <label onMouseEnter={
                            ()=>handleMouseEnter("#fff","#333","")}
             onMouseLeave={handleMouseLeave} className={"boxCard-outer"}>
                           <div >Years </div> 
             <input type="radio" title="Set As Years"   checked={durationTypeVal=="years"?"yes":""}
  className="input-textbox"  value="years"  name="courseExpiryType1"  
  onClick={e=>{changeDurationType(e.target.value);;setDurationTypeVal(e.target.value);;}}/>
       <span class={"boxCardBorder"}></span> </label>
       <label onMouseEnter={
                            ()=>handleMouseEnter("#fff","#333","")}
             onMouseLeave={handleMouseLeave} className={"boxCard-outer"}>
                           <div > Months </div> 
             <input type="radio" title="Set As Months"   checked={durationTypeVal=="months"?"yes":""}
  className="input-textbox"  value="months"  name="courseExpiryType1"  
  onChange={e=>{changeDurationType(e.target.value);;setDurationTypeVal(e.target.value);;}}/>
       <span class={"boxCardBorder"}></span> </label> <label onMouseEnter={
                            ()=>handleMouseEnter("#fff","#333","")}
             onMouseLeave={handleMouseLeave} className={"boxCard-outer"}>
                           <div >Days </div> 
             <input type="radio" title="Set As Days"   checked={durationTypeVal=="days"?"yes":""}
  className="input-textbox"  value="days"  name="courseExpiryType1"  
  onChange={e=>{changeDurationType(e.target.value);setDurationTypeVal(e.target.value);}}/>
       <span class={"boxCardBorder"}></span> </label>
       </div>  </div>                   
                       <div style={{marginTop: '20px' ,gridTemplateColumns:  "15% 70% 15%" , }}>
 {!loaderTrialValue?.status? <Minus  onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  onClick={()=>{setTotalNo(parseInt(totalNo)>1?parseInt(totalNo)-1:1)
    changetotalNumber(parseInt(totalNo)>1?parseInt(totalNo)-1:1);
  }} style={{float:"left",background:"#555555 ",width:"35px",height:"35px",borderRadius:"50%",marginRight:"10px",
        alignContent:"center",textAlign:"center",padding:"8px",cursor:"pointer"}} color="#fff" size={22}/>:<CircleMinus  onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}  onClick={()=>{}} style={{float:"left",background:"#555555 ",width:"35px",height:"35px",borderRadius:"50%",marginRight:"10px",
           alignContent:"center",textAlign:"center",padding:"8px",cursor:"pointer"}} color="#fff" size={22}/>}
    <input onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  value={parseInt(totalNo)} type="number"
          onChange={(e)=>{changetotalNumber(e.target.value);setTotalNo(e.target.value);}}
          style={{border:"2px dashed #555555  ",borderRadius:"10px",outline:0,float:"left",width:"55%",
            padding:"10px",fontSize:"30px",color:"#555555 ",fontWeight:"bolder"}}
      /> {!loaderTrialValue?.status? <Plus onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}  onClick={()=>{setTotalNo(parseInt(totalNo)+1)
        changetotalNumber(parseInt(totalNo)+1);
      }}  style={{float:"left",background:"#555555 ",width:"35px",height:"35px",borderRadius:"50%",marginLeft:"10px",
        alignContent:"center",textAlign:"center",padding:"8px",cursor:"pointer"}}  color="#fff" size={22}/>:<CirclePlus onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}  onClick={()=>{ }}  style={{float:"left",background:"#555555 ",width:"35px",height:"35px",borderRadius:"50%",marginLeft:"10px",
          alignContent:"center",textAlign:"center",padding:"8px",cursor:"pointer"}}  color="#fff" size={22}/>}
        
        
        
        </div>                </div>
      :<div  className="CreateCourseStepsOuterLeft"style={{
        transform: animate ? 'scale(1)' : 'scale(.9)',marginTop:"20px",marginBottom:"0px",
        opacity: animate ? 1 : 0,
        transition: 'transform 2s ease, opacity 1s ease',
      }}>
<div className="anim_line">
          
<span><img src={anim_line} alt="anim_line"/></span>
<span><img src={anim_line} alt="anim_line"/></span>
<span><img src={anim_line} alt="anim_line"/></span>
           </div>
           <FrameIcon size={60}   color="rgba(144, 202, 249,1)" /> 
   

<div class="CreateCourseStepsOuterTitle"> Enable Free Trial !!! </div>
{/* {courseTitleData},
     {token},{postIdCourse },{user_email},{currentToken},{AppToken} */}
     <p>Now You May Enable Duration Based Or Expiry Based Free Trial. </p>
</div>}



    </div>
 <div></div> <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
    <div  >   </div>
  
    
    <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{history.push(`${baseUrl}/additional-info`)}}  className="CreateCourseStepsOuterRightButtonBack"  type="submit"
     id="signupBtn"> Back </button>

 <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{history.push(`${baseUrl}/seo`)}} style={{width:"140px",height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
     id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":productID?"Go Next":"Go Next"} </button>
     
  </div>
 {goNextPopUp?<NextStepCardPopUp loadingText="Going Next..."  title="Next Step> Create Mock Tests & Add Contents.   Let's Go Next" type="addAproxContent"
 closePopUp={()=>{setGoNextPopUp(false)}}
 onClickPopup={(type)=>{setTimeout(()=>{
  history.push(`${baseUrl}/approx-material`)
 },1000)
  }}/>:""}

<div style={{height:"70px"}}></div>
  </div></div>
</>}
    </>

}

export default FreeTrial;

